import { Card, Skeleton, CardContent, Stack, Paper } from '@mui/material'
import { useTheme } from '@thriveglobal/thrive-web-leafkit'
import { CardDetails } from '../Card'

export default function FeaturedCardSkeleton() {
    const theme = useTheme()

    return (
        <Card
            sx={{
                mt: 3,
                backgroundColor: theme.palette.background.paper,
                boxShadow: theme.shadows[9]
            }}
        >
            <CardContent
                sx={{
                    p: '0',
                    '&:last-child': {
                        paddingBottom: 0
                    }
                }}
            >
                <Stack direction={{ xs: 'column', md: 'row' }}>
                    <Paper
                        sx={{
                            position: 'relative',
                            boxShadow: 'none',
                            width: '40%',
                            [theme.breakpoints.down('md')]: {
                                width: '100%'
                            }
                        }}
                    >
                        <Skeleton
                            variant="rectangular"
                            height={'100%'}
                            animation="wave"
                        />
                    </Paper>

                    <Stack
                        direction="column"
                        sx={{
                            width: '60%',
                            p: theme.spacing(2),
                            [theme.breakpoints.down('md')]: {
                                width: '100%'
                            }
                        }}
                    >
                        <CardDetails
                            topLeftContent={
                                <Skeleton
                                    variant="text"
                                    width={120}
                                    height={50}
                                />
                            }
                            topRightContent={
                                <Skeleton
                                    variant="text"
                                    width={120}
                                    height={50}
                                />
                            }
                            bottomLeftContent={
                                <Skeleton
                                    variant="text"
                                    width={120}
                                    height={50}
                                />
                            }
                        />
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    )
}
